/* Digital gift cards: local video preparation, first-party QR generation and verified cart attachment.
   Each attempt has its own ID. A lost response is reconciled, never blindly retried. */
(function () {
  'use strict';
  var UPLOADS = 'https://cdn.shopify.com/s/files/1/0931/6217/6896/uploads/';
  var scripts = {};
  function hosted(value, ext) {
    return typeof value === 'string' && value.indexOf(UPLOADS) === 0 &&
      new RegExp('^[A-Za-z0-9_-]+\\.(' + ext + ')$', 'i').test(value.slice(UPLOADS.length)) ? value : '';
  }
  function load(src, globalName) {
    if (window[globalName]) return Promise.resolve(window[globalName]);
    if (!scripts[src]) scripts[src] = new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      var timer = setTimeout(fail, 20000);
      function fail() {
        clearTimeout(timer); script.remove(); delete scripts[src];
        reject(new Error('We could not prepare your video. Check your connection and try again.'));
      }
      script.src = src; script.async = true;
      script.onerror = fail;
      script.onload = function () {
        if (!window[globalName]) return fail();
        clearTimeout(timer); resolve(window[globalName]);
      };
      document.head.appendChild(script);
    });
    return scripts[src];
  }
  function playback(file) {
    return new Promise(function (resolve, reject) {
      var video = document.createElement('video'), url = URL.createObjectURL(file), done = false;
      var timer = setTimeout(function () { finish(new Error('We could not check this video. Try a shorter video.')); }, 15000);
      function finish(error) {
        if (done) return; done = true; clearTimeout(timer);
        video.oncanplay = video.onerror = null;
        video.pause(); video.removeAttribute('src'); video.load(); URL.revokeObjectURL(url);
        if (error) reject(error); else resolve();
      }
      video.preload = 'auto'; video.muted = true; video.playsInline = true;
      video.oncanplay = function () {
        finish(video.videoWidth > 0 && video.videoHeight > 0 && Number.isFinite(video.duration) && video.duration > 0
          ? null : new Error('This file does not contain a playable video. Choose another video.'));
      };
      video.onerror = function () { finish(new Error('This browser cannot play this video. Choose another video or export it as an MP4.')); };
      video.src = url; video.load();
    });
  }
  async function qrFile(url, library) {
    var qr = library.QrCode.encodeText(url, library.QrCode.Ecc.MEDIUM);
    var canvas = document.createElement('canvas'), scale = 8, border = 4;
    canvas.width = canvas.height = (qr.size + border * 2) * scale;
    var ctx = canvas.getContext('2d');
    if (!ctx) throw new Error('We could not prepare your video QR code. Try another browser.');
    ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, canvas.width, canvas.height); ctx.fillStyle = '#000';
    for (var y = 0; y < qr.size; y++) for (var x = 0; x < qr.size; x++) {
      if (qr.getModule(x, y)) ctx.fillRect((x + border) * scale, (y + border) * scale, scale, scale);
    }
    var blob = await new Promise(function (resolve) { canvas.toBlob(resolve, 'image/png'); });
    if (!blob) throw new Error('We could not prepare your video QR code. Try another browser.');
    return new File([blob], 'gift-video-qr.png', { type: 'image/png' });
  }
  window.c4uGiftCardVideo = function (root, changed) {
    var box = root.querySelector('[data-c4ugc-video]');
    var input = root.querySelector('[data-c4ugc-file]'), drop = root.querySelector('[data-c4ugc-drop]');
    var label = root.querySelector('[data-c4ugc-drop-text]'), clear = root.querySelector('[data-c4ugc-clear]');
    var status = root.querySelector('[data-c4ugc-video-status]');
    var defaultLabel = label.textContent, selected = null, checking = false, invalid = false;
    var selection = 0, stop = null, locked = false;
    var cartRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
    function message(text, error) {
      status.textContent = text; status.setAttribute('data-state', error ? 'error' : 'info');
    }
    function reset() {
      selection++; if (stop) stop.abort(); stop = null;
      selected = null; checking = invalid = false; input.value = ''; label.textContent = defaultLabel;
      clear.hidden = true; message(''); changed();
    }
    async function select(file) {
      if (!file || locked) return;
      reset(); invalid = true; clear.hidden = false;
      if (!/\.(mp4|mov)$/i.test(file.name) || (file.type && !/^(video\/mp4|video\/quicktime)$/.test(file.type))) {
        message('Choose an MP4 or MOV video. Other formats are not supported yet.', true); return;
      }
      if (!file.size || file.size > 100 * 1024 * 1024) { message('Choose a video up to 100 MB.', true); return; }
      var current = selection;
      checking = true; label.textContent = file.name;
      message('Checking your video. It has not been uploaded yet.'); changed();
      try {
        await playback(file);
        if (current !== selection) return;
        var ready = file;
        if (file.size > 19000000) {
          message('Making your video smaller. Keep this page open.');
          stop = new AbortController();
          var shrink = await load(box.dataset.shrinkSrc, 'c4uShrinkVideo');
          if (current !== selection) return;
          ready = await shrink(file, { maxBytes: 18000000, signal: stop.signal, onProgress: function (p) {
            if (current === selection) message('Making your video smaller: ' + Math.round(p * 100) + '%. Keep this page open.');
          } });
          if (current !== selection) return;
          await playback(ready);
        }
        if (current !== selection) return;
        if (!ready || ready.size > 19000000) throw new Error('This video is too large to upload. Choose a shorter video.');
        selected = ready; invalid = false;
        message('Video selected: ' + file.name + '. It will upload when you add the gift card to your basket.');
      } catch (error) {
        if (current !== selection) return;
        message(error.message || 'We could not prepare this video. Choose another video.', true);
      } finally {
        if (current === selection) { checking = false; stop = null; changed(); }
      }
    }
    root.querySelector('[data-c4ugc-video-tabs]').hidden = false;
    root.querySelectorAll('[data-c4ugc-mode]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (locked) return;
        var mode = button.dataset.c4ugcMode;
        root.querySelectorAll('[data-c4ugc-mode]').forEach(function (b) {
          var on = b === button;
          b.setAttribute('aria-pressed', String(on)); b.classList.toggle('custom-prd7k9__gift-opt--on', on);
        });
        root.querySelectorAll('[data-c4ugc-pane]').forEach(function (p) { p.hidden = p.dataset.c4ugcPane !== mode; });
      });
    });
    input.addEventListener('change', function () { select(input.files[0]); });
    clear.addEventListener('click', function () { if (!locked) reset(); });
    ['dragover', 'dragenter', 'dragleave', 'drop'].forEach(function (name) {
      drop.addEventListener(name, function (e) {
        e.preventDefault();
        drop.classList.toggle('custom-prd7k9__gift-drop--over', !locked && (name === 'dragover' || name === 'dragenter'));
        if (name === 'drop' && e.dataTransfer) select(e.dataTransfer.files[0]);
      });
    });
    async function request(path, options, timeout) {
      var controller = new AbortController(), timer = setTimeout(function () { controller.abort(); }, timeout || 25000);
      try {
        var response = await fetch(cartRoot + path, Object.assign({ credentials: 'same-origin', cache: 'no-store' }, options, { signal: controller.signal }));
        var body = await response.json().catch(function () { return null; });
        if (!response.ok || !body) {
          var error = new Error(body && (typeof body.description === 'string' ? body.description : body.message) || 'We could not confirm your basket.');
          error.body = body; error.rejected = response.status >= 400 && response.status < 500;
          throw error;
        }
        return body;
      } finally { clearTimeout(timer); }
    }
    async function add(data, progress) {
      var file = selected, library = file ? await load(box.dataset.qrSrc, 'qrcodegen') : null;
      var id = window.crypto.randomUUID ? window.crypto.randomUUID() : Array.from(window.crypto.getRandomValues(new Uint8Array(16)), function (n) { return n.toString(16).padStart(2, '0'); }).join('');
      var variant = data.get('id'), quantity = Number(data.get('quantity') || 1);
      data.set('properties[_Gift upload ID]', id);
      if (file) data.set('properties[Gift video]', file, file.name);
      var expected = {};
      data.forEach(function (v, k) { if (k.indexOf('properties[') === 0 && typeof v === 'string') expected[k.slice(11, -1)] = v; });
      function owned(cart) { return cart.items.filter(function (i) { return i.properties && i.properties['_Gift upload ID'] === id; }); }
      function verified(lines, withQr) {
        if (lines.length !== 1) return null;
        var line = lines[0], props = line.properties || {};
        if (String(line.variant_id || line.id) !== String(variant) || line.quantity !== quantity || !line.key) return null;
        if (!Object.keys(expected).every(function (key) { return String(props[key]).replace(/\r\n/g, '\n') === expected[key].replace(/\r\n/g, '\n'); })) return null;
        if (file && !hosted(props['Gift video'], 'mp4|mov')) return null;
        if (withQr && !hosted(props['_Gift video QR'], 'png')) return null;
        return line;
      }
      async function read() {
        var cart = await request('cart.js');
        if (!Array.isArray(cart.items)) throw new Error('We could not verify your basket.');
        return cart;
      }
      function review() {
        var error = new Error('We could not confirm this gift card. Review your basket before trying again.');
        error.review = true; return error;
      }
      var line;
      progress(file ? 'Uploading your video. Please keep this page open.' : 'Adding to your basket...');
      try {
        await request('cart/add.js', { method: 'POST', body: data, headers: { Accept: 'application/json' } }, 120000);
      } catch (error) {
        if (error.rejected) throw error;
        try { line = verified(owned(await read()), false); } catch (readError) { throw review(); }
        if (!line) throw review(); // The original upload may still be running. Never retry it automatically.
      }
      if (!line) {
        try { line = verified(owned(await read()), false); } catch (error) { throw review(); }
      }
      if (!line) throw review();
      if (!file) return line;
      var url = 'https://candy4u.co.uk/pages/gift-video?v=' + line.properties['Gift video'].slice(UPLOADS.length);
      expected['Gift video'] = line.properties['Gift video'];
      progress('Adding the video QR code to your gift card...');
      try {
        var png = await qrFile(url, library), change = new FormData();
        change.set('id', line.key); change.set('quantity', String(quantity));
        Object.keys(line.properties).forEach(function (key) { change.set('properties[' + key + ']', line.properties[key]); });
        change.set('properties[_Gift video QR]', png, png.name);
        await request('cart/change.js', { method: 'POST', body: change, headers: { Accept: 'application/json' } }, 120000);
        var finalLine = verified(owned(await read()), true);
        if (!finalLine) throw new Error('The video QR could not be verified.');
        return finalLine;
      } catch (error) {
        // A lost QR reply can still be a complete gift. Otherwise remove only this attempt's line.
        try {
          var lines = owned(await read()), recovered = verified(lines, true);
          if (recovered) return recovered;
          for (var i = 0; i < lines.length; i++) {
            await request('cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: lines[i].key, quantity: 0 }) });
          }
          if (owned(await read()).length) throw new Error('Removal not confirmed');
        } catch (cleanupError) { throw review(); }
        throw new Error('Your video QR could not be attached, so this gift card was removed from the basket. Please try again.');
      }
    }
    return {
      busy: function () { return checking; },
      valid: function () { if (invalid) message('Choose a playable video, or remove the selected video to continue.', true); return !invalid && !checking; },
      lock: function (value) { locked = value; }, reset: reset, add: add
    };
  };
})();
